/*!
 * Copyright (c) HoaDev and contributors. All rights reserved.
 * More licensed under license file.
 * Created by HoaDev, 10/06/2022
 */
import { CONFIG_WORKFLOW_APP_PREFIX_URL } from "./config.home-app";

interface MenuItemInterface {
  key: string;
  label: string;
  onClick?: () => void;
  icon?: any;
}

// Tạo list menu con demo
export const LIST_MENU: MenuItemInterface[] = [
  {
    key: CONFIG_WORKFLOW_APP_PREFIX_URL + "/form",
    label: "Forms (Biểu mẫu)",
  },
  {
    key: CONFIG_WORKFLOW_APP_PREFIX_URL + "/wf",
    label: "Workflows (Quy trình)",
  },
];
